import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Tablet(props) {
    return (
        <SvgIcon {...props}>
            <path d="M0,2.624v9.752C0,12.719,0.281,13,0.624,13h13.751C14.719,13,15,12.719,15,12.376V2.624 C15,2.281,14.719,2,14.375,2H0.624C0.281,2,0,2.281,0,2.624z M14.519,7.5c0,0.316-0.256,0.572-0.572,0.572 c-0.316,0-0.573-0.256-0.573-0.572s0.256-0.572,0.573-0.572C14.263,6.928,14.519,7.184,14.519,7.5z M13.146,3.144v8.855 L1.01,11.99V3.135L13.146,3.144z" />
        </SvgIcon>
    );
}

Tablet.defaultProps = {
    viewBox: '0 0 15 16'
};

export default Tablet;
